import Vue from "vue";

const state = {
    profile: {
        applications: null,
    },
};

const actions = {
    getMe: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            Vue.axios
                .get("/users/me")
                .then(resp => {
                    commit("setUser", resp.data);
                    resolve(resp);
                })
                .catch(err => {
                    // handle error?
                    reject(err);
                });
        });
    },

    changePassword: ({ state, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            Vue.axios
                .patch("/users/me/password", {
                    password: payload.password,
                    password_confirmation: payload.passwordConfirm,
                })
                .then(resp => {
                    dispatch("handleSuccess", "Your information was updated successfully.");
                    resolve(resp);
                })
                .catch(err => {
                    let errorMessage;

                    if (err && err.response && err.response.data && err.response.data.message) {
                        errorMessage = err.response.data.message;
                        if (err.response.data.errors && Object.keys(err.response.data.errors).length) {
                            errorMessage += " Please correct the following:";

                            for (const prop in err.response.data.errors) {
                                errorMessage += " " + err.response.data.errors[prop][0];
                            }
                        }
                    } else if (err) {
                        errorMessage = err;
                    } else {
                        errorMessage = "An unknown error occurred";
                    }

                    dispatch("handleError", errorMessage);
                    reject(err);
                });
        });
    },

    updateProfile: ({ state, dispatch }) => {
        return new Promise((resolve, reject) => {
            Vue.axios
                .patch("/users/me", {
                    first_name: state.profile.first_name,
                    last_name: state.profile.last_name,
                    email: state.profile.email,
                })
                .then(resp => {
                    dispatch("getMe");
                    dispatch("handleSuccess", "Your information was updated successfully.");
                    resolve(resp);
                })
                .catch(err => {
                    let errorMessage;

                    if (err && err.response && err.response.data && err.response.data.message) {
                        errorMessage = err.response.data.message;
                        if (err.response.data.errors && Object.keys(err.response.data.errors).length) {
                            errorMessage += " Please correct the following:";

                            for (const prop in err.response.data.errors) {
                                errorMessage += " " + err.response.data.errors[prop][0];
                            }
                        }
                    } else if (err) {
                        errorMessage = err;
                    } else {
                        errorMessage = "An unknown error occurred";
                    }

                    dispatch("handleError", errorMessage);
                    reject(err);
                });
        });
    },

    clearCurrentUser: ({ commit }) => {
        commit("clearCurrentUser");
    },
};

const mutations = {
    setUser: (state, data) => {
        state.profile = data.user;
    },

    clearCurrentUser: (state) => {
        state.profile = null;
    },
};

export default {
    state,
    actions,
    mutations,
};